import PropTypes from 'prop-types'
import React, { Component } from 'react'

import getDisplayName from 'client-react/utils/getDisplayName'
import EditorSimple from 'client-react/components/EditorSimple'
import { loadEditor } from 'plugins/loader'

const identity = (arg) => arg

const emptyState = {
  type: null,
  editor: null,
  loadHook: null,
  saveHook: null,
  typeValidate: null,
  loading: true,
  error: null,
}

const editorLoader = (WrappedComponent) => {
  class WithEditor extends Component {
    constructor (props) {
      super(props)
      this.state = emptyState
      // Flag pour suivre le montage et éviter du `Warning: Can't perform a React state update on an unmounted component. This is a no-op, but it indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks in the componentWillUnmount method.
      this._isMounted = false
    }

    async ensureEditor () {
      try {
        const { ressource: { type } = {} } = this.props
        if (!type || type === this.state.type) return
        const {
          editor = EditorSimple,
          loadHook = identity,
          saveHook = identity,
          validate: typeValidate,
        } = await loadEditor(type)

        if (this._isMounted) {
          this.setState({
            type,
            editor,
            loadHook,
            saveHook,
            typeValidate,
            loading: false,
          })
        }
      } catch (error) {
        console.error("Erreur lors du chargement de l'éditeur :", error)
        if (this._isMounted) {
          this.setState({ error, loading: false })
        }
      }
    }

    componentDidMount () {
      this._isMounted = true
      this.ensureEditor()
    }

    componentDidUpdate () {
      this.ensureEditor()
    }

    componentWillUnmount () {
      this._isMounted = false
    }

    render () {
      if (!this.props.ressource) return null

      const { editor, loadHook, saveHook, typeValidate, loading, error } =
        this.state

      if (loading) {
        return <div>Chargement de l’éditeur en cours...</div>
      }

      if (error) {
        return (
          <div className="alert--danger">
            Erreur lors du chargement de l’éditeur : {error.message}
          </div>
        )
      }

      const { ressource, ...othersProps } = this.props
      const wrappedProps = {
        ...othersProps,
        initialValues: loadHook(ressource),
        editor,
        saveHook,
        typeValidate
      }

      return (
        <WrappedComponent {...wrappedProps} />
      )
    }
  }

  WithEditor.displayName = `editorLoader(${getDisplayName(WrappedComponent)})`

  WithEditor.propTypes = {
    ressource: PropTypes.shape({
      type: PropTypes.string.isRequired,
    }).isRequired
  }

  return WithEditor
}

export default editorLoader
